module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei5.svg";